<script setup>
import { ref, reactive } from 'vue';
import { useStore } from 'vuex';
import apiManager from '@/api';
import BigModal from './BigModal.vue';

const emit = defineEmits(['close', 'registered']);

const store = useStore();

const solutions = ref(JSON.parse(JSON.stringify(store.state.solutions.solutions)));

const successTimeout = 10000;

const success = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const error = reactive({
  value: false,
  message: '',
  timeout: successTimeout,
});

const register = async (inputs) => {
  // map payload
  const { user } = inputs;

  const payload = {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    phone: user.phone,
    companyName: user.companyName,
    zip: user.zip,
    interestedInFordProSolutions: user.userProfileQuestion.interestedInFordProSolutions,
    notifyOfNews: user.userProfileQuestion.allowContactInterested,
    notifyOfNewEvents: user.userProfileQuestion.allowContactOutside,
  };

  // submit notification registration
  try {
    await apiManager.notify.register(payload);
    success.message = 'Congratulations! You will now receive notifications for events that match your interests.';
    success.value = true;
  } catch (e) {
    if (e.response.status === 409) {
      success.message = 'Looks like you are already signed up for notifications. We have updated your information!';
      success.value = true;
    } else {
      error.message = 'We are very sorry. Something went wrong, try again later.';
      error.value = true;
    }
  } finally {
    setTimeout(() => {
      emit('registered');
    }, successTimeout);
  }
};

</script>
<template>
  <big-modal
    @validated="register"
    @close="() => emit('close')"
    title="Stay In The Know"
    subTitle="
      We put the Pro in Productivity. Discover how Ford Pro can be a productivity
      accelerator for your business.
    "
    submitButtonText="Notify Me"
    :success="success"
    :error="error"
    :solutions="solutions"
    :has-not-interested="false"
    interested-text="I’d like to stay in the know about the latest news,
      products, and innovative solutions from Ford Pro."
    outside-text="Keep me posted about future in-person events, webinars,
      and on-demand opportunities to learn more about Ford Pro Solutions."
    :showQuestion="false" />
</template>
